export default "__VITE_ASSET__DgoOwZ2h__"